// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Poppins_6a4d19', '__Poppins_Fallback_6a4d19'","fontStyle":"normal"},"className":"__className_6a4d19","variable":"__variable_6a4d19"};